import * as TickersConstants from '../constants/tickers-constants'

const initialState = {
    loading: false,
    putTickerSuccess: false,
    errorMessage: '',
    error: false,
    getTickresSuccess: false,
    tickersData: {}
};

export const tickersReducer = (state = initialState, action) => {
    switch (action.type) {
        // put Ticker
        case TickersConstants.CREATE_TICKER_BEGIN:
            return {
                ...state,
                loading: true,
                errorMessage: "",
                error: false,
                putTickerSuccess: false,
            };
        case TickersConstants.CREATE_TICKER_SUCCESS:
            return {
                ...state,
                loading: false,
                putTickerSuccess: true,
            };
        case TickersConstants.CREATE_TICKER_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: action.error.message,
                error: true,
            };

        // get Tickes
        case TickersConstants.GET_TICKER_BEGIN:
            return {
                ...state,
                errorMessage: "",
                loading: true,
                error: false,
                getTickresSuccess: false,
            };
        case TickersConstants.GET_TICKER_SUCCESS:
            return {
                ...state,
                loading: false,
                tickersData: action.data.data,
                getTickresSuccess: true,
            };
        case TickersConstants.GET_TICKER_FAILURE:
            return {
                ...state,
                errorMessage: action.error.message,
                error: true,
                loading: false
            };

        default:
            return state
    }
}